$ = require 'jquery'
templates = require 'app/scripts/views/internal/templates'

module.exports = Tooltip = new class
  constructor: ->
    @tooltip = null

  show: (tooltipHtml, $anchor, closeable = true, style = @STYLE.DEFAULT) ->
    $(window).on 'click', $anchor[0], @windowClick

    clearTimeout(@emptyTimer)

    if (typeof tooltipHtml.renderOnce == 'function')
      tooltipHtml = tooltipHtml.renderOnce().$el.html()

    if (@tooltip?.tooltipHtml == tooltipHtml && @tooltip?.$anchor[0] == $anchor[0])
      return

    $elem = $(templates.fill(require('app/scripts/views/templates/tooltip_content'), { tooltipHtml, closeable, style }))

    # remove all classes except @TOOLTIP_CONTAINER
    $tooltip = $('.' + @TOOLTIP_CONTAINER).attr('class', @TOOLTIP_CONTAINER)

    if style != @STYLE.DEFAULT
      $tooltip.addClass('tooltip-' + style)

    $tooltip.html $elem
    @tooltip = {
      tooltipHtml
      $anchor
      $elem
    }

    { left: anchorLeft, top: anchorTop } = $anchor.offset()
    anchorHeight = $anchor.outerHeight()
    minRightOffset = window.innerWidth - $tooltip.outerWidth()

    $tooltip.css
      left: Math.min(Math.max(anchorLeft - 5, 5), minRightOffset)
      top: Math.max(anchorTop + anchorHeight, 5)

    $elem.addClass('active')

  windowClick: (e) ->
    $target = $(e.target)
    if (e.target != e.data &&
    $target.closest('.js-tooltip-content').length == 0 ||
    $target.closest('.js-tooltip-close-button').length != 0)
      Tooltip.hide()

  hide: ->
    @tooltip = null
    $tooltip = $('.' + @TOOLTIP_CONTAINER)
    $tooltip
      .find('.tooltip-content')
      .removeClass('active')
    @emptyTimer = setTimeout =>
      $tooltip.empty()
    , 300

    $(window).off 'click', @windowClick

  STYLE: {
    DEFAULT: 'default',
    MENU: 'menu',
    BILLING: 'billing'
  }

  TOOLTIP_CONTAINER: 'tooltip-container'
